<template>
  <div class="sidebar-filters">
    <b-button class="text-uppercase" ref="escape" variant="reset-all" @click.prevent="resetFilters()">
      <i class="fas fa-eraser" /> {{ 'Reset all filters' | translate }}
    </b-button>
    <status-list-filter
      @edit="editComponentFilters($event, 'filter__status__in')"
      @clean="cleanComponentFilters(['filter__status__in'])"
    />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { TYPES as TASK_CATEGORY_TYPES } from './store'
import CommonFiltersMixin from '../../common-filters/CommonFiltersMixin'

export default {
  name: 'TaskCategoryCommonFilters',
  mixins: [CommonFiltersMixin],
  computed: {
    ...mapGetters({
      filters: TASK_CATEGORY_TYPES.GENERIC.task['task-category'].LIST.GETTERS.filters
    })
  },
  methods: {
    ...mapActions({
      ...TASK_CATEGORY_TYPES.GENERIC.task['task-category'].LIST.ACTIONS
    })
  }
}
</script>
